import { css } from 'lit';

export const GridStyle = css`
.row {
  display: flex;
  flex-wrap: wrap;
}

.wrapper {
  margin: 0 auto;
}

.pt-1 {
  padding-top: 1rem;
}

.ml-auto {
  margin-left: auto !important;
}

.order-md-1 {
  order: 1 !important;
}

.order-md-2 {
  order: 2 !important;
}

.col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}

.col-md-3 {
  flex: 0 0 25%;
  max-width: 25%;
}

.col-md-9 {
  flex: 0 0 75%;
  max-width: 75%;
}

.col-md-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
}
`;
export default GridStyle;
